import { RICH_TEXT_SUPPORTED_HTML_TAGS, RICH_TEXT_UNDERLINE_TAG } from './richText.constants';

const UNDERLINE_TAG = /<(\/?)u(\s[^>]*)?>/gi;

const SUPPORTED_TAG_OPENING = `/?(?:${RICH_TEXT_SUPPORTED_HTML_TAGS.join('|')})(?:\\s|/|>)`;

const AUTOLINK_OPENING = '[a-z][a-z0-9+.-]*:';

const UNSUPPORTED_TAG_OPENING = new RegExp(
  `<(?!${SUPPORTED_TAG_OPENING})(?!${AUTOLINK_OPENING})`,
  'gi',
);

export const prepareRichTextContent = (content: string) =>
  content
    .replace(UNDERLINE_TAG, `<$1${RICH_TEXT_UNDERLINE_TAG}>`)
    .replace(UNSUPPORTED_TAG_OPENING, '&lt;');
